import React from "react";

import { PLACEHOLDER_PRODUCT_IMAGE_URL_40 } from "../../../../utils/constants";
import { ProductImageProps } from "./product-image.types";

export const ProductImage = (props: ProductImageProps) => (
  <img src={props.imageUrl || PLACEHOLDER_PRODUCT_IMAGE_URL_40} width="40" alt={props.title} />
);
